<div class="arrow-wrap">
  <div class="arrow" [ngClass]="arrowPosition!"></div>
  <div class="feature-tooltip">
    <div class="header-wrap">
      <div class="icon-header-container">
        @if (isNew || badgeCopy) {
          <rt-badge
            color="primary"
            [text]="isNew ? ('app.common.new' | translate) : badgeCopy!"
            margin-right-small-x
          />
        }
        <span class="header"> {{ title() }} </span>
      </div>
      <rt-icon-button
        shape="square"
        size="small"
        iconName="close"
        variant="transparent-light"
        (click)="close.emit()"
      />
    </div>
    <div class="body">
      <span class="info" [innerHTML]="description()"></span>
      @if (learnMore && !learnMoreAsButton()) {
        <a
          [href]="learnMore"
          [innerHTML]="
            learnMoreCopy() || ('app.common.see_how_it_works' | translate) | rtPreventOrphans
          "
          (click)="learnMoreClick.emit()"
          target="_blank"
          margin-left-small-xxx
        ></a>
      }
      <div class="actions" [class.row-reverse]="ctaPosition() === 'right'" margin-top-small>
        <rt-button (click)="ctaClick.emit()" variant="tertiary">
          {{ ctaText() || ('app.feature_tooltip.okay_got_it' | translate) }}
          @if (ctaHasChevron()) {
            <rt-icon suffix name="chevron-right" />
          }
        </rt-button>
        @if (learnMore && learnMoreAsButton()) {
          <a
            [href]="learnMore"
            (click)="learnMoreClick.emit()"
            target="_blank"
            rt-button
            variant="plain-ghost"
          >
            {{ learnMoreCopy() || ('app.common.see_how_it_works' | translate) }}
            <rt-icon name="open-in-new" suffix />
          </a>
        }
      </div>
    </div>
  </div>
</div>
